const LOCAL_RETURN_ORIGIN = "https://local.invalid";

/** Return a normalized same-origin, non-login return path, or undefined for unsafe input. */
export function safeLocalReturnPath(value: unknown): string | undefined {
  if (typeof value !== "string" || !value.startsWith("/")) return undefined;
  try {
    const parsed = new URL(value, LOCAL_RETURN_ORIGIN);
    if (parsed.origin !== LOCAL_RETURN_ORIGIN) return undefined;
    if (parsed.pathname === "/login" || parsed.pathname === "/login/") return undefined;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return undefined;
  }
}

/** Build a same-origin login URL for an expired authenticated session. */
export function expiredSessionLoginPath(currentPath: string): string {
  const safePath = safeLocalReturnPath(currentPath);
  if (!safePath) return "/login?session=expired";
  const params = new URLSearchParams({ session: "expired" });
  params.set("next", safePath);
  return `/login?${params.toString()}`;
}
